export enum PriceListsFormValue {
  KTDESCRIPTION = 'KitDescription',
  PRICE = 'Price',
  QUANTITY = 'Quantity',

}
